/* eslint-disable */
export default {
  unknown: 'Onbekend',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
